<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-toolbarBg">
        <ejs-toolbar :items="toolbarItems"></ejs-toolbar>
        <div class='h-inputBox'>
          <ejs-textbox v-model='keyword' :placeholder='$t("Pm.reportTask.name")' @keyup.enter.native="filterReportTask" maxLength='20'></ejs-textbox>
        </div>
      </div>
      <div class="h100-80 h-scroll">
        <ejs-grid :dataSource="reportTaskData" :allowPaging="true" ref="grid" :pageSettings="pageSettings" :height="screenHeight" :allowExcelExport='true' >
          <e-columns>
            <e-column type="checkbox" width="50" textAlign="center"></e-column>
            <e-column field="id" :visible="false"></e-column>
            <e-column field="name" :headerText="$t('Pm.reportTask.name')" width="120" textAlign="Center"></e-column>
            <e-column field="exeCycle" :headerText="$t('Pm.reportTask.exeCycle')" :formatter='exeCycleFormat' width="120" textAlign="Center"></e-column>
            <e-column field="startTime" :headerText="$t('Pm.reportTask.startTime')" :format="dateFormat" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
            <e-column field="endTime" :headerText="$t('Pm.reportTask.endTime')" :format="dateFormat" width="120" textAlign="Center" clipMode="EllipsisWithTooltip"></e-column>
            <e-column field="format" :headerText="$t('Pm.reportTask.format')"  width="120" textAlign="Center"></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager
          ref="pager"
          :pageSize="pageSettings.pageSize"
          :pageCount="page.pageCount"
          :currentPage="page.pageNo"
          :totalRecordsCount="page.totalRecordsCount"
          @click="getReportTaskList"
        ></ejs-pager>
      </div>
      <CustomDialog ref="addReportTaskDialog" v-bind:element="addDialog.element" v-bind:styles="addDialog.styles" >
        <template v-slot:dialog-content>
          <AddReportTask ref="addReportTaskPage"></AddReportTask>
        </template>
      </CustomDialog>
      <CustomDialog ref="editReportTaskDialog" v-bind:element="editDialog.element" v-bind:styles="editDialog.styles" >
        <template v-slot:dialog-content>
          <EditReportTask ref="editReportTaskPage"></EditReportTask>
        </template>
      </CustomDialog>
      <CustomDialog ref="pmReportTaskLogDialog" v-bind:element="logDialog.element" v-bind:styles="logDialog.styles" >
        <template v-slot:dialog-content>
          <PmReportTaskLog ref="pmReportTaskLogPage"></PmReportTaskLog>
        </template>
      </CustomDialog>    
      <CustomDialog ref="templateAddTaskDialog" v-bind:element="templateDialog.element" v-bind:styles="templateDialog.styles" >
        <template v-slot:dialog-content>
          <TemplateAddTask ref="templateAddTaskPage"></TemplateAddTask>
        </template>
      </CustomDialog>    </template>
  </BasicLayout>
</template>
<script>
import CustomDialog from "../../../components/common/CustomDialog";
import BasicLayout from '../../../layouts/BasicLayout';
import AddReportTask from './pmReportTaskGnb/addReportTask';
import EditReportTask from './pmReportTaskGnb/editReportTask';
import PmReportTaskLog from './PmReportTaskLog';
import TemplateAddTask from './pmReportTaskGnb/templateAddTask';
import {ExcelExport} from '@syncfusion/ej2-vue-grids';

export default {
  name: 'reportTask',
  provide: {
    grid: [ExcelExport]
  },
  components: {
    CustomDialog,
    BasicLayout,
    AddReportTask,
    EditReportTask,
    PmReportTaskLog,    
    TemplateAddTask  
  },
  data() {
    return {
      reportTaskData: [],
      left: { show: false, name: '' },
      middle: { show: false, name: '' },
      right: { show: true, crumb: `${this.$t('Pm.pmManagement')}`+'/' + `${this.$t('Pm.gnbManagement')}` + '/' + `${this.$t('Pm.reportTaskTile')}` },
      toolbarItems: [
        { prefixIcon: 'icon hero-icon hero-icon-add', tooltipText: this.$t('Security.add'), click: this.showAddDialog },
        { prefixIcon: 'icon hero-icon hero-icon-add', tooltipText: this.$t('Pm.templateAddTask'), click: this.showTemplateAddDialog },
        { prefixIcon: 'icon hero-icon hero-icon-edit', tooltipText: this.$t('Security.modify'), click: this.showEditDialog },
        { prefixIcon: 'icon hero-icon hero-icon-remove', tooltipText: this.$t('Security.delete'), click: this.deleteReportTask },
        { prefixIcon: 'icon hero-icon hero-icon-statistics', tooltipText: this.$t('Pm.reportTask.exeTask'), click: this.exeReportTask },
        { prefixIcon: 'icon hero-icon hero-icon-task-tracking', tooltipText: this.$t('Pm.reportTask.taskLog'), click: this.reportTasklog },
        { prefixIcon: 'icon hero-icon hero-icon-refresh', tooltipText: this.$t('Alarm.refresh'), click: this.refreshGrid },
      ],
      keyword: '',
      pageSettings: { pageSize: 15 },
      page: {
        pageCount: 4,
        totalRecordsCount: 0,
        pageNo: 1,
      },
      dateFormat: {
        type: 'date', format: 'yyyy-MM-dd'
      },
      addStatus: true,
      addDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'addReportTaskDialog',
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.addReportTask,
              buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            }
          ],
          title: `${this.$t('Pm.addReportTask')}`
        },
        styles: {
          width: '860px',
          height: '700px',
          model: true,
          visible: false
        }
      },
      editDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'editReportTaskDialog',
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.editReportTask,
              buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            }
          ],
          title: `${this.$t('Pm.updateReportTask')}`
        },
        styles: {
          width: '860px',
          height: '700px',
          model: true,
          visible: false
        }
      },
      logDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'pmReportTaskLogDialog',
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
          ],
          title: `${this.$t('Pm.reportTaskLogTile')}`
        },
        styles: {
          width: '860px',
          height: '700px',
          model: true,
          visible: false
        }
      },
      templateDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: 'templateAddTaskDialog',
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.templateAddTask,
              buttonModel: { content: `${this.$t('Common.ok')}`, cssClass: 'primary-btn' }
            }
          ],
          title: `${this.$t('Pm.templateAddTask')}`
        },
        styles: {
          width: '860px',
          height: '700px',
          model: true,
          visible: false
        }
      },      
      screenHeight: document.body.clientHeight - 240
    };
  },
  mounted() {
    this.getReportTaskList();
    let That = this;
  },
  methods: {
    exeCycleFormat(grids, data) {
      if(data.exeCycle == 1){
        return `${this.$t('Pm.reportTask.hours')}`;
      }else if(data.exeCycle == 2){
        return `${this.$t('Pm.reportTask.days')}`;
      }else if(data.exeCycle == 3){
        return `${this.$t('Pm.reportTask.weeks')}`;
      }else if(data.exeCycle == 4){
        return `${this.$t('Pm.reportTask.months')}`;
      }else if(data.exeCycle == 5){
        return `${this.$t('Pm.reportTask.fixedDays')}`;
      }
    },
    getReportTaskList() {
      const url = '/lte/ems/pm/gnb/report/task/query';
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = { params: {
        name: this.keyword,
        pageNo: this.page.pageNo,
        pageSize: this.pageSettings.pageSize
      } };
      const That = this;
      this.axios.get(url, params).then(response => {
        const result = response.data.result;
        result.forEach((v) => {
          if (!!v.exeTime) {
            let date = new Date();
            date.setTime(v.exeTime);
            v.exeTime = date;
          }
          if (!!v.startTime) {
            let date = new Date();
            date.setTime(v.startTime);
            v.startTime = date;
          }
          if (!!v.endTime) {
            let date = new Date();
            date.setTime(v.endTime);
            v.endTime = date;
          }
        });
        That.reportTaskData = result;
        That.page.totalRecordsCount = response.data.totalCount;
      });
    },
    filterReportTask() {
      this.getReportTaskList();
    },
    getRecord() {
      const result = this.$refs.grid.getSelectedRecords();
      if (result === null || result === '') {
        this.$parent.showToast('warning',`${this.$t('Common.tips.noSelect')}`);
        return null;
      }
      return result;
    },
    showTemplateAddDialog() {
      this.$refs.templateAddTaskPage.init();
      this.$refs.templateAddTaskDialog.show();
    },
    showAddDialog() {
      this.$refs.addReportTaskPage.init();
      this.$refs.addReportTaskDialog.show();
    },
    showEditDialog() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      if (record.length !== 1) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return null;
      }
      this.editId = record[0].id;
      this.$refs.editReportTaskPage.editInit(this.editId);
      this.$refs.editReportTaskDialog.show();
    },
    reportTasklog() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      if (record.length !== 1) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return null;
      }
      this.reportTaskId = record[0].id;
      this.$refs.pmReportTaskLogPage.init(this.reportTaskId);
      this.$refs.pmReportTaskLogDialog.show();
    },
    deleteReportTask() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      const url = '/lte/ems/pm/gnb/report/task/delete';
      const params = [];
      record.forEach((r, i) => {
        params.push(r.id);
      });
      let That = this;
      this.$layer.confirm({
        msg: `${this.$t('Common.tips.confirmTip')}`,
        btn1: {
          msg: `${this.$t('Common.cancel')}`
        },
        btn2: {
          msg: `${this.$t('Common.ok')}`,
          func: () => {
            That.axios.post(url, params).then(response => {
              if (response.data) {
                That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
                That.getReportTaskList();
              } else {
                That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
              }
            });
          }
        }
      });
    },
    exeReportTask() {
      const record = this.getRecord();
      if (record.length === 0) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.selectOne')}`);
        return null;
      }
      if (record.length !== 1) {
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return null;
      }
      const url = '/lte/ems/pm/gnb/report/task/exeTask';
      const params = { params: {
        id: record[0].id,
      } };
      const That = this;
      That.axios.get(url, params).then(response => {
        if (response.data) {
          That.$parent.showToast('success', `${this.$t('Pm.reportTask.exeTaskSuccess')}`);
          That.getReportTaskList();
        } else {
          That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
        }
      });
    },
    templateAddTask() {
      let status = this.$refs.templateAddTaskPage.templateValidation();
      if(!status){
        return;
      }
      let choose = this.$refs.templateAddTaskPage.getCheckedData();
      if(!choose){
        return;
      }
      const url = '/lte/ems/pm/gnb/report/task/add';
      const reportTaskInfo = this.$refs.templateAddTaskPage.getReportTask();
      if(reportTaskInfo == null) {
        return;
      }
      let That = this;
      this.axios.post(url, reportTaskInfo).then(response => {
        const result = response.data;
        if(result) {
          That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
          That.getReportTaskList();
          That.$refs.templateAddTaskDialog.clear();
          That.$refs.templateAddTaskDialog.close();
        } else {
          That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
        }
      });
    },
    addReportTask() {
      let status = this.$refs.addReportTaskPage.validation();
      if(!status){
        return;
      }
      const url = '/lte/ems/pm/gnb/report/task/add';
      const reportTaskInfo = this.$refs.addReportTaskPage.getReportTask();
      if(reportTaskInfo == null) {
        return;
      }
      let That = this;
      this.axios.post(url, reportTaskInfo).then(response => {
        const result = response.data;
        if(result) {
          That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
          That.getReportTaskList();
          That.$refs.addReportTaskDialog.clear();
          That.$refs.addReportTaskDialog.close();
        } else {
          That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
        }
      });
    },
    editReportTask() {
      let status = this.$refs.editReportTaskPage.validation();
      if(!status){
        return;
      }
      const url =  '/lte/ems/pm/gnb/report/task/edit';
      const reportTaskInfo = this.$refs.editReportTaskPage.getReportTask();
      if(reportTaskInfo == null) {
        return;
      }
      let That = this;
      this.axios.post(url, reportTaskInfo).then(response => {
        const result = response.data;
        if(result) {
          That.$parent.showToast('success', `${this.$t('Common.tips.success')}`);
          That.getReportTaskList();
          That.$refs.editReportTaskDialog.clear();
          That.$refs.editReportTaskDialog.close();
        } else {
          That.$parent.showToast('error', `${this.$t('Common.tips.failure')}`);
        }
      });
    },
    dialogHide() {
      this.$refs.addReportTaskDialog.clear();
      this.$refs.addReportTaskDialog.close();
      this.$refs.editReportTaskDialog.clear();
      this.$refs.editReportTaskDialog.clear();      
      this.$refs.pmReportTaskLogDialog.clear();
      this.$refs.pmReportTaskLogDialog.clear();
      this.$refs.templateAddTaskDialog.clear();
      this.$refs.templateAddTaskDialog.clear();    },
    refreshGrid() {
      this.getReportTaskList();
    },
    copyDeep(templateData) {
      const returnData = JSON.parse(JSON.stringify(templateData));
      returnData.buttonGroup.forEach((item, index) => {
        item.click = templateData.buttonGroup[index].click;
      });
      return returnData;
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        // EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
        this.$parent.showToast('warning',`${this.$t('Alarm.no_checked')}`);

        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        // EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        this.$parent.showToast('warning',`${this.$t('Common.tips.onlyOneSelect')}`);
        return false;
      }
      return selectedRecords;
    },
  },
  watch: {
    screenHeight(val) {
      this.screenHeight = val;
    }
  }
};
</script>
